module.exports = "<div class=\"container main-container\">\n  <app-template></app-template>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/angular/15.angularFormularios - Template/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main